/* Counter: static final values remain readable without JS. */
(()=>{
 const seen=new WeakSet();
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 function init(root=document){
  if(reduced.matches||!('IntersectionObserver' in window))return;
  const observer=new IntersectionObserver(entries=>{
   for(const entry of entries){
    if(!entry.isIntersecting)continue;
    const el=entry.target;observer.unobserve(el);
    if(el.dataset.counted==='true')continue;
    el.dataset.counted='true';
    const original=el.textContent.trim();
    const match=original.match(/\d[\d.,]*/);
    if(!match)continue;
    const target=Number(match[0].replace(/[^0-9]/g,''));
    if(!Number.isSafeInteger(target)||target<0)continue;
    const duration=Math.max(1000,Math.min(4000,Number(el.dataset.duration)||2200));
    const formatter=new Intl.NumberFormat('es-ES',{useGrouping:true});
    let start;
    const frame=now=>{
     if(!el.isConnected)return;
     if(start===undefined)start=now;
     const progress=Math.min(1,(now-start)/duration);
     if(progress>=1||reduced.matches){el.textContent=original;return;}
     const amount=Math.floor(target*(1-Math.pow(1-progress,3)));
     el.textContent=original.replace(match[0],formatter.format(amount));
     window.requestAnimationFrame(frame);
    };
    window.requestAnimationFrame(frame);
   }
  },{threshold:0.35});
  root.querySelectorAll('[data-ag-counter]').forEach(el=>{if(!seen.has(el)){seen.add(el);observer.observe(el);}});
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();
